var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "theme-background-pane" },
    [
      !_vm.hasTheme
        ? _c(
            "div",
            {
              staticClass:
                "theme-background-pane__state alert alert-warning text-center",
              attrs: { role: "alert" },
            },
            [_vm._v("\n    Theme is not selected. Please select theme\n  ")]
          )
        : _c("ExternalContentView", {
            ref: "content",
            attrs: {
              endpoint: "/banner/background-list",
              "page-size": _vm.pageSize,
              "extra-params": _vm.params,
              "show-search": false,
              "external-preview": true,
              "show-copy-to-file-browser": _vm.cropped === "0",
            },
            on: {
              onSelectedItems: (items) => _vm.$emit("onSelectedItems", items),
              "open-preview": (item) => _vm.$emit("open-preview", item),
              "copy-to-file-browser": (item) =>
                _vm.$emit("copy-to-file-browser", item),
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }